// btw-front/src/pages/AdminDealNew.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import Container from "../components/ui/Container";
import AdminDealForm, { emptyForm, quarterFromDate } from "../components/admin/AdminDealForm";
import { usePartnerSession } from "../context/PartnerSessionContext";
import { create as createAdminDeal } from "../api/adminDeals";

export default function AdminDealNew() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { profile } = usePartnerSession();

  const [form, setForm] = useState(() => emptyForm());
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(ev) {
    ev.preventDefault();
    if (submitting) return;
    if (
      !form.projectName ||
      !form.customerCompany ||
      !form.customerContactName ||
      !form.adminSalesRepId
    ) {
      message.warning(t("partners.signup.errors.required"));
      return;
    }
    setSubmitting(true);
    try {
      await createAdminDeal({
        ...form,
        poExpectedQuarter: quarterFromDate(form.poExpectedDate),
      });
      message.success(t("admin.deals.submitted"));
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg =
        (err && err.payload && err.payload.error && err.payload.error.message) ||
        t("admin.deals.createFailed");
      message.error(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <Navbar />
      <main className="flex-1 py-10 md:py-14">
        <Container>
          <div className="mx-auto max-w-4xl">
            <h1 className="text-2xl font-bold text-slate-900 md:text-3xl">
              {t("admin.deals.newTitle")}
            </h1>
            <AdminDealForm
              form={form}
              setForm={setForm}
              adminCompany={profile?.company || ""}
              representativeName={profile?.representativeName || ""}
              submitting={submitting}
              onSubmit={handleSubmit}
              cancelTo="/admin"
              submitLabel={t("partners.deals.form.submit")}
            />
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
